import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseDeleteTagCategoryMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

interface DeleteTagCategoryMutationParams {
	impersonationContext?: Api.IImpersonationContext;
	categoryId: string;
	deleteTags?: boolean;
}

export function useDeleteTagCategoryMutation({ onSuccess, onError }: UseDeleteTagCategoryMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ categoryId, deleteTags, impersonationContext }: DeleteTagCategoryMutationParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `tagcategory/${categoryId}`,
					queryParams: {
						deleteTags,
					},
				}),
				'DELETE'
			);
		},
		onSuccess,
		onError,
	});
}
